import React from 'react'
import CountDownTimer, {
  CountDownTimerSettings,
} from 'Event/Dashboard/components/CountDownTimer'
import EditableCountDownTimer, {
  CountDownTimerContainer,
} from 'Event/Dashboard/components/CountDownTimer/EditableCountDownTimer'
import {useEditMode} from 'Event/EditModeProvider'
import {useCardsTemplate} from 'Event/template/Cards'

type CountDownTimerProps = {
  id: string
  countDownTimer: CountDownTimerSettings
  index: number
}

export default React.memo((props: CountDownTimerProps) => {
  const isEditMode = useEditMode()
  const {countDownTimers, localization} = useCardsTemplate()

  const countDownTimer = (
    <CountDownTimer {...props.countDownTimer} id={props.id} />
  )

  if (!isEditMode) {
    return <CountDownTimerContainer>{countDownTimer}</CountDownTimerContainer>
  }

  return (
    <EditableCountDownTimer
      id={props.id}
      countDownTimer={props.countDownTimer}
      index={props.index}
      keyPath={`countDownTimers.${props.id}`}
      countDownTimers={countDownTimers}
      localization={localization}
    >
      {countDownTimer}
    </EditableCountDownTimer>
  )
})
